import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { first } from 'rxjs/operators';
import { Organizer } from '../../models';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DashboardOrganizerService {
  private http = inject(HttpClient);

  configUrl = environment.apiUrl;

  getOrganizer(organizerId: number): Observable<Organizer> {
    const route = `${this.configUrl}organizer/${organizerId}`;
    return this.http.get<Organizer>(route).pipe(
      first(),
    );
  }

  updateOrganizer(organizer: Organizer) {
    const route = `${this.configUrl}organizer`;

    return this.http.put(route, organizer).pipe(
      first(),
    );
  }

}
